<template>
  <v-btn color="primary" v-on="$listeners" >
    <v-icon v-html="`mdi-rotate-3d-variant`" />
    {{ $t('button.refresh') }}
  </v-btn>
</template>
<script>

export default {
  name: 'RefreshButton'
}
</script>
